import React, { useEffect, useRef } from 'react';
import i18n from 'i18n-js';
import { Box, Button, Grid } from '@material-ui/core';
import { useStyles } from './Common.styled';

const VariableBufferDeleteMessage = ({ onClose }) => {
  const classes = useStyles();
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div ref={tooltipRef}>
      <Grid className={classes.tooltipContainer} container direction="column">
        <Grid item xs={12}>
          {i18n.t('reservation_rulesets.deleted_confirmation')}
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              className={classes.deleteTooltipButton}
              type="button"
              variant="text"
              onClick={onClose}
            >
              {i18n.t('common.ok')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default VariableBufferDeleteMessage;
